import type { FC } from 'react';
import { Trans } from 'next-i18next';
import styles from './CouponEmptyBlock.module.scss';
const CouponEmptyBlock: FC = () => {
  return <div className={styles.root} data-sentry-component="CouponEmptyBlock" data-sentry-source-file="CouponEmptyBlock.tsx">
      <div className={styles.text}>
        <Trans i18nKey="sport:coupon.empty_text" data-sentry-element="Trans" data-sentry-source-file="CouponEmptyBlock.tsx">{'Your coupon is empty. <br/> Add an event to the coupon.'}</Trans>
      </div>
    </div>;
};
export { CouponEmptyBlock };